module.exports = __webpack_public_path__ + "img/menu-hair-3.3ad68e1a.jpg";